import { createAction } from 'redux-actions';
import { reduxKey } from '../constants';
export const attemptSocialLogin = createAction(`${reduxKey}.ATTEMPT_SOCIAL_LOGIN`, (params)=>params);
export const initializeFacebookJSSDK = createAction(`${reduxKey}.FACEBOOK.INIT`, ()=>({}));
export const setSocialLoginError = createAction(`${reduxKey}.SET_ERROR`, (errorCode)=>({
        errorCode
    }));
// Callback actions
export const socialLoginSuccess = createAction(`${reduxKey}.LOGIN_SUCCESS`, (params)=>params);

//# sourceMappingURL=actions.js.map